(() => {
  if (window.__joffzCollectionPresentationV71) return;
  window.__joffzCollectionPresentationV71 = true;

  const ROOT_SELECTOR = '.collection-grid-section .product-card[data-product]';
  const EDITORIAL_GROUP_SELECTOR = '[data-joffz-collection-editorial-group]';
  const EDITORIAL_SELECTOR = '[data-joffz-collection-editorial]';
  const WISHLIST_SELECTORS = [
    '.wk-button-product','.wk-product-button','.wk-button','.wkh-button','.swym-button',
    '.swym-add-to-wishlist','.wishlist-engine-button','[data-wishlist-button]','[data-wishlist]',
    'button[class*="wishlist"]','a[class*="wishlist"]','[aria-label*="wishlist" i]',
    '[title*="wishlist" i]','[aria-label*="favorite" i]','[aria-label*="favourite" i]'
  ];

  const mainRoot = () => document.getElementById('MainContent') || document.body;
  const shopifySection = (node) => node?.closest?.('.shopify-section') || node || null;
  const getEditorialGroup = () => mainRoot()?.querySelector(EDITORIAL_GROUP_SELECTOR) || mainRoot()?.querySelector(EDITORIAL_SELECTOR);

  const moveEditorial = () => {
    const root = mainRoot();
    const editorialGroup = getEditorialGroup();
    if (!root || !editorialGroup || editorialGroup.dataset.joffzEditorialPositioned === 'true') return;

    const editorial = editorialGroup.matches(EDITORIAL_SELECTOR) ? editorialGroup : editorialGroup.querySelector(EDITORIAL_SELECTOR);
    const suffix = editorial?.dataset.templateSuffix || '';
    let target = null;

    if (suffix === 'posters') {
      const hiddenBanner = root.querySelector('.collection-banner-section');
      target = hiddenBanner?.nextElementSibling || root.querySelector('.image-collage-banner')?.closest('.shopify-section');
    } else {
      target = shopifySection(root.querySelector('.jpc-listing-controller-section')) || shopifySection(root.querySelector('.collection-grid-section'));
    }

    if (!target) target = root.querySelector('.shopify-section');

    if (target?.parentNode && target !== editorialGroup) {
      if (editorialGroup.parentNode !== target.parentNode || editorialGroup.nextElementSibling !== target) {
        target.parentNode.insertBefore(editorialGroup, target);
      }
      editorialGroup.dataset.joffzEditorialPositioned = 'true';
    }
  };

  const normalizeWishlistControl = (candidate, card) => {
    if (!(candidate instanceof Element)) return null;
    const interactive = candidate.closest('button, a, [role="button"]') || candidate;
    if (!card.contains(interactive)) return null;
    if (interactive.closest('.wishlist-header-link, header, .drawer, cart-drawer')) return null;
    return interactive;
  };

  const findWishlistControl = (card) => {
    for (const selector of WISHLIST_SELECTORS) {
      const control = normalizeWishlistControl(card.querySelector(selector), card);
      if (control) return control;
    }
    return null;
  };

  const promoteCardUi = (card) => {
    if (!(card instanceof Element)) return;
    const labelSets = Array.from(card.querySelectorAll('.jpc-card-labels'));
    const keeper = labelSets.shift();
    labelSets.forEach((duplicate) => duplicate.remove());
    if (keeper && keeper.parentElement !== card) card.insertBefore(keeper, card.firstChild);
    const wishlist = findWishlistControl(card);
    if (wishlist) wishlist.classList.add('joffz-card-wishlist-control');
  };

  const scanCards = (scope = mainRoot()) => {
    if (!scope) return;
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(promoteCardUi);
    if (scope.matches?.(ROOT_SELECTOR)) promoteCardUi(scope);
  };

  const init = () => {
    const root = mainRoot();
    if (!root || root.dataset.joffzCollectionObserverV79 === 'true') return;
    root.dataset.joffzCollectionObserverV79 = 'true';

    moveEditorial();
    scanCards(root);

    let queued = false;
    const pendingCards = new Set();
    let shouldMoveEditorial = false;

    const flush = () => {
      queued = false;
      pendingCards.forEach((card) => { if (card.isConnected) promoteCardUi(card); });
      pendingCards.clear();
      if (shouldMoveEditorial) {
        shouldMoveEditorial = false;
        const editorialGroup = getEditorialGroup();
        if (editorialGroup) editorialGroup.dataset.joffzEditorialPositioned = 'false';
        moveEditorial();
      }
    };

    const queue = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(flush);
    };

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          const parentCard = node.closest(ROOT_SELECTOR);
          if (parentCard) pendingCards.add(parentCard);
          node.querySelectorAll?.(ROOT_SELECTOR).forEach((card) => pendingCards.add(card));
          if (
            node.matches?.(`${EDITORIAL_GROUP_SELECTOR}, ${EDITORIAL_SELECTOR}, .jpc-listing-controller-section, .collection-grid-section`) ||
            node.querySelector?.(`${EDITORIAL_GROUP_SELECTOR}, ${EDITORIAL_SELECTOR}, .jpc-listing-controller-section, .collection-grid-section`)
          ) shouldMoveEditorial = true;
        }
      }
      if (pendingCards.size || shouldMoveEditorial) queue();
    });

    observer.observe(root, { childList: true, subtree: true });
    window.setTimeout(() => scanCards(root), 320);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  document.addEventListener('shopify:section:load', (event) => {
    const editorialGroup = getEditorialGroup();
    if (editorialGroup) editorialGroup.dataset.joffzEditorialPositioned = 'false';
    moveEditorial();
    scanCards(event.target || mainRoot());
  });
})();
